import { lazy } from "react";

export const SignInRoute = lazy(() =>
  import("./sign-in-route").then((m) => ({ default: m.SignInRoute })),
);
export const InstallRoute = lazy(() =>
  import("./install-route").then((m) => ({ default: m.InstallRoute })),
);

export const LibraryRoutePage = lazy(() =>
  import("./product/library-route-page").then((m) => ({ default: m.LibraryRoutePage })),
);
export const InboxRoutePage = lazy(() =>
  import("./product/inbox-route-page").then((m) => ({ default: m.InboxRoutePage })),
);
export const RejectedRoutePage = lazy(() =>
  import("./product/rejected-route-page").then((m) => ({ default: m.RejectedRoutePage })),
);
export const CanonicalCollectionRoutePage = lazy(() =>
  import("./product/canonical-collection-route-page").then((m) => ({
    default: m.CanonicalCollectionRoutePage,
  })),
);
export const PersonalCollectionRoutePage = lazy(() =>
  import("./product/personal-collection-route-page").then((m) => ({
    default: m.PersonalCollectionRoutePage,
  })),
);
export const TeamRoutePage = lazy(() =>
  import("./product/team-route-page").then((m) => ({ default: m.TeamRoutePage })),
);
export const TeamMemberRoutePage = lazy(() =>
  import("./product/team-member-route-page").then((m) => ({ default: m.TeamMemberRoutePage })),
);
export const TeamCollectionRoutePage = lazy(() =>
  import("./product/team-collection-route-page").then((m) => ({
    default: m.TeamCollectionRoutePage,
  })),
);

export const SettingsAccountRoutePage = lazy(() =>
  import("./settings/account-route-page").then((m) => ({ default: m.SettingsAccountRoutePage })),
);
export const SettingsUsersRoutePage = lazy(() =>
  import("./settings/users-route-page").then((m) => ({ default: m.SettingsUsersRoutePage })),
);
export const SettingsPromptsRoutePage = lazy(() =>
  import("./settings/prompts-route-page").then((m) => ({ default: m.SettingsPromptsRoutePage })),
);
export const SettingsArchivedRoutePage = lazy(() =>
  import("./settings/archived-route-page").then((m) => ({ default: m.SettingsArchivedRoutePage })),
);
export const SettingsIntegrationsRoutePage = lazy(() =>
  import("./settings/integrations-index-route-page").then((m) => ({
    default: m.SettingsIntegrationsRoutePage,
  })),
);
export const SettingsSlackRoutePage = lazy(() =>
  import("./settings/integrations-slack-route-page").then((m) => ({
    default: m.SettingsSlackRoutePage,
  })),
);
export const SettingsMiroRoutePage = lazy(() =>
  import("./settings/integrations-miro-route-page").then((m) => ({
    default: m.SettingsMiroRoutePage,
  })),
);
export const SettingsWorkOSRoutePage = lazy(() =>
  import("./settings/integrations-workos-route-page").then((m) => ({
    default: m.SettingsWorkOSRoutePage,
  })),
);
export const SettingsAirtableRoutePage = lazy(() =>
  import("./settings/integrations-airtable-route-page").then((m) => ({
    default: m.SettingsAirtableRoutePage,
  })),
);

export const TalentRoutePage = lazy(() =>
  import("./product/talent-route-page").then((m) => ({ default: m.TalentRoutePage })),
);
